


<!-- Navbar -->
 <nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a href="#/dashboard" class="nav-link">Inicio</a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a href="#" class="nav-link"></a>
    </li>
  </ul>

  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">
    <!-- Navbar Search -->
 

    <!-- Messages Dropdown Menu -->
    <li class="nav-item dropdown">
      <a class="nav-link" data-toggle="dropdown" href="#">
        <i class="far fa-comments"></i>
        <span class="badge badge-danger navbar-badge">    {{pubNombreUsuario}}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
        <a href="#" class="dropdown-item">
          <!-- Message Start -->
          <div class="media">
           
            <div class="media-body">
              <h3 class="dropdown-item-title">
               Ver Perfil
                <span class="float-right text-sm text-danger"  ><i class="fas fa-star"></i></span>
              </h3>
             
            </div>
          </div>
          <!-- Message End -->
        </a>
       
       
       
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item dropdown-footer" (click)="logout()">Cerrar sesión</a>
      </div>
    </li>
    <!-- Notifications Dropdown Menu -->
  
   
   
  </ul>
   
  </nav>
  <!-- /.navbar -->


